"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionsMenuList = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var usePermissionLevelDisplayNames_1 = require("./usePermissionLevelDisplayNames");
var usePermissionObject_1 = require("./usePermissionObject");
var usePermissionsModalContext_1 = require("./usePermissionsModalContext");
var fontStyles = {
    fontSize: 'md',
    fontWeight: 'normal',
};
var PermissionsMenuList = function (_a) {
    var permissionLevel = _a.permissionLevel, _b = _a.onChange, onChange = _b === void 0 ? function () { } : _b;
    var _c = (0, usePermissionObject_1.usePermissionObject)(), objectType = _c.objectType, objectId = _c.objectId;
    var usePermissionLevels = (0, usePermissionsModalContext_1.usePermissionsModalContext)().usePermissionLevels;
    var _d = usePermissionLevels(objectType, objectId).data, possiblePermissionLevels = _d === void 0 ? [] : _d;
    var permissionLevelDisplayNames = (0, usePermissionLevelDisplayNames_1.usePermissionLevelDisplayNames)();
    var handleOnChange = React.useCallback(function (permissionLevel) {
        onChange(permissionLevel);
    }, [onChange]);
    var nonePermissionLevel = 'none';
    return (React.createElement(react_1.MenuList, { boxShadow: "md" },
        React.createElement(react_1.MenuOptionGroup, { value: permissionLevel, onChange: handleOnChange, type: "radio" },
            possiblePermissionLevels.map(function (possiblePermissionLevel) { return (React.createElement(react_1.MenuItemOption, { key: possiblePermissionLevel, value: possiblePermissionLevel, sx: fontStyles }, permissionLevelDisplayNames[possiblePermissionLevel])); }),
            React.createElement(react_1.MenuDivider, null),
            React.createElement(react_1.MenuItemOption, { value: nonePermissionLevel, sx: fontStyles }, permissionLevelDisplayNames[nonePermissionLevel]))));
};
exports.PermissionsMenuList = PermissionsMenuList;
